export {
    IIMRSelectGrid,
    IMRSelectGridOptions,
    IMRSelectGridInitializedArgs,
    IMRSelectGridObjectSelected,
    IMRSelectGridObjectsSelected,
    IMRSelectGridSelectionChanged
} from './select-grid/select-grid.interfaces'

export { SELECT_GRID_MODULE_NAME } from './select-grid.module'
